import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { usersService } from 'api/configuration/users'
import { Modal } from 'components/reusables/modal'
import { ModalButtons } from 'components/reusables/modalButtons'
import { useNotification } from 'hooks/notifications/useNotification'

interface IProps {
  users: number[]
  refreshView: () => Promise<void>
  close: () => void
}

export const Remove = ({ users, refreshView, close }: IProps) => {
  const { t } = useTranslation()
  const notification = useNotification()
  const prefix =
    'configuration.rolesAndPermissions.users.actions.removeAllRoles.modal'
  const [processing, setProcessing] = useState(false)

  const remove = async () => {
    setProcessing(true)
    try {
      await usersService.removeAllUserPermissions(users)
      notification.success(
        t(`${prefix}.notifications.success`).replace(
          '{count}',
          users.length.toString()
        )
      )
      await refreshView()
      close()
    } finally {
      setProcessing(false)
    }
  }

  return (
    <Modal
      isOpen={true}
      title={t(`${prefix}.title`)}
      isConfirmation={true}
      maxwidth={800}
      maxheight={204}
      close={close}
      actions={
        <ModalButtons
          primaryText={t(`${prefix}.buttons.removePermissions`)}
          primaryAction={remove}
          secondaryText={t(`${prefix}.buttons.cancel`)}
          secondaryAction={close}
          processing={processing}
        />
      }
    >
      <>
        {`${t(`${prefix}.descriptionPrefix`)} `}
        <span style={{ fontWeight: 'bold' }}>
          {t(`${prefix}.selectedUsers`).replace(
            '{count}',
            users.length.toString()
          )}
        </span>
        {` ${t(`${prefix}.descriptionSuffix`)}`}
      </>
    </Modal>
  )
}

export default Remove
